//#region src/utils/accessibleName.ts
/**
* Passes the rest of a destructure on as the control's accessible name.
*
* - A prop left in the rest, besides the three names, fails type-check.
*/
const forwardAccessibleName = (rest) => rest;
//#endregion
export { forwardAccessibleName };

//# sourceMappingURL=accessibleName.js.map